function configs(labels, datasets) {
  const maxValue = Math.max(...datasets.flatMap((item) => item.data || []));

  return {
    data: {
      labels,
      datasets: datasets.map((item) => ({
        label: item.label,
        backgroundColor: item.backgroundColor,
        data: item.data,
        borderRadius: 4,
        barThickness: 8,
        categoryPercentage: 0.6,
        barPercentage: 0.8,
      })),
    },

    options: {
      responsive: true,
      maintainAspectRatio: false,
      indexAxis: "y",

      plugins: {
        legend: {
          display: true,
          position: "bottom",
        },

        tooltip: {
          mode: "index",
          intersect: true,
        },
      },

      scales: {
        x: {
          beginAtZero: true,
          min: 0,
          max: Math.ceil(maxValue),

          ticks: {
            stepSize: 1,
            color: "#000",
          },

          grid: {
            color: "#e0e0e0",
          },
        },

        y: {
          ticks: {
            color: "#000",
          },

          grid: {
            display: false,
          },
        },
      },
    },
  };
}

export default configs;
